import React from 'react';

const TableElementReadOnly = (props) => {
    return (
        <table className="table table-bordered">
            <thead className='text-white' style={{ backgroundColor: 'var(--theme-dark-gray)' }}>
                <tr>
                    <th width="80px" className="text-center">#</th>
                    {props.columns.map(r => <th key={r.id}>{r.name}</th>)}
                </tr>
            </thead>
            <tbody>
                {
                    Object.entries(props.data).length > 0 ? (
                        Object.entries(props.data).map(([ks, rs], key) => (
                            <tr key={ks}>
                                <td className="text-center">{key + 1}</td>
                                {props.columns.map((c, k) => (
                                    <td key={k} dangerouslySetInnerHTML={{__html:rs[c.id]?.content}} />
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center" colSpan={props.columns.length + 1}>
                                No Data Found
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    );
}

TableElementReadOnly.defaultProps = {
    columns: [],
    data: [],
}

export default TableElementReadOnly;
